/* Diagnóstico: mi impresora de etiquetas imprime mal.
 *
 * Sintoma -> causas ORDENADAS de lo gratis a lo caro -> la pieza concreta
 * compatible con SU referencia.
 *
 * El orden no es decorativo: casi todo esto se arregla limpiando o
 * recalibrando, y mandar a alguien a comprar un cabezal de 300 € cuando tenia
 * el sensor descalibrado seria venderle lo que no necesita. Cada causa dice
 * primero que comprobar sin gastar.
 *
 * Los datos de compatibilidad se leen EN VIVO por el mismo camino que el
 * buscador de consumibles:
 *   /search/suggest.json?resources[type]=collection   resuelve el modelo
 *   /collections/<h>?view=compatibles                 sus referencias
 *   /products/<h>?view=compatibles                    sus piezas
 *
 * SIN cabecera Accept: con `Accept: application/json` Shopify ignora el
 * `?view=` y devuelve su propio JSON. Eso tuvo dos dias roto al buscador y no
 * se veia con curl, que no manda esa cabecera.
 */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-di]');
  if (!raiz) return;

  var zonaSintomas = raiz.querySelector('#di-sintomas');
  var zonaTec = raiz.querySelector('#di-tecnologia');
  var zonaRes = raiz.querySelector('#di-resultado');
  var zonaPieza = raiz.querySelector('#di-pieza');
  var aviso = raiz.querySelector('#di-aviso');
  var cargando = raiz.querySelector('#di-cargando');

  var PAUSA = 150;
  var cache = {};
  var estado = { sintoma: null, tecnologia: null };

  /* ---------- Contenido: el criterio, que es lo que vale ---------- */

  var TT = 'transferencia térmica';
  var DT = 'térmica directa';

  var SINTOMAS = [
    {
      id: 'blanco',
      titulo: 'Sale en blanco: no se ve nada impreso',
      pregunta: true,
      causas: [
        { si: DT, t: 'La etiqueta va del revés, o no es térmica',
          c: ['El papel térmico solo reacciona por una cara. Rasca la superficie con una uña: si deja una marca gris oscura, esa es la cara buena y debe mirar al cabezal.',
              'Si no deja marca por ninguna cara, no es papel térmico y con térmica directa no va a imprimir nunca.'] },
        { si: TT, t: 'Falta el ribbon, o está montado del revés',
          c: ['Con transferencia térmica sin ribbon no se imprime nada, aunque la etiqueta salga limpia.',
              'El lado entintado va hacia la etiqueta. Pega un trozo de celo al ribbon y tira: si la tinta se queda en el celo, esa es la cara entintada.'] },
        { t: 'El cabezal está sucio', pieza: 'limpieza',
          c: ['Límpialo con alcohol isopropílico y un bastoncillo, en frío y con la impresora apagada.',
              'Es la causa más frecuente y la más barata. Hazlo antes de sospechar de nada más.'] },
        { t: 'El cabezal está agotado', pieza: 'Cabezales de impresión',
          c: ['Si tras limpiarlo sigue sin imprimir NADA en toda la anchura, el cabezal está para cambiar.',
              'Un cabezal dura entre 25 y 50 km de material según el modelo; con uso intensivo son uno o dos años.'] }
      ]
    },
    {
      id: 'rayas',
      titulo: 'Salen rayas blancas verticales a lo largo de la etiqueta',
      causas: [
        { t: 'Suciedad o adhesivo pegado en el cabezal', pieza: 'limpieza',
          c: ['Una raya blanca continua es casi siempre un punto tapado, no roto.',
              'Limpia con alcohol isopropílico. Si la raya desaparece, era eso.'] },
        { t: 'Puntos quemados del cabezal', pieza: 'Cabezales de impresión',
          c: ['Si la raya sigue exactamente en el mismo sitio después de limpiar, hay puntos muertos y el cabezal no se recupera.',
              'Imprime el patrón de prueba del equipo: las rayas saldrán también ahí, lo que descarta que sea cosa del diseño o del driver.'] },
        { t: 'Ribbon más estrecho que la etiqueta',
          c: ['Si el ribbon no cubre todo el ancho, los bordes salen sin imprimir y además el cabezal roza directamente la etiqueta y se desgasta antes.',
              'El ribbon debe ser igual o algo más ancho que el material.'] }
      ]
    },
    {
      id: 'clara',
      titulo: 'La impresión sale clara, débil o se borra',
      causas: [
        { t: 'Temperatura demasiado baja o velocidad demasiado alta',
          c: ['Sube el darkness en pasos pequeños y baja la velocidad. Es gratis y resuelve la mayoría de los casos.',
              'A más velocidad, menos tiempo de contacto: lo que a 4 ips sale perfecto puede salir gris a 10 ips.'] },
        { t: 'El ribbon no es el adecuado para ese material', pieza: 'Ribbons y cintas',
          c: ['El ribbon de cera no fija sobre etiqueta sintética: necesita cera-resina o resina.',
              'Si la impresión se borra al frotarla con el dedo, es esto casi con seguridad.'] },
        { t: 'Cabezal sucio', pieza: 'limpieza',
          c: ['Una capa fina de residuo baja el rendimiento antes de llegar a producir rayas.'] },
        { t: 'Presión desigual del cabezal',
          c: ['Si la impresión sale clara solo por un lado, ajusta la presión de ese lado.',
              'En las industriales hay dos reguladores; en las de sobremesa suele ser uno.'] }
      ]
    },
    {
      id: 'saltos',
      titulo: 'Se salta etiquetas o avanza de más',
      causas: [
        { t: 'Sensor sin calibrar',
          c: ['Ejecuta la calibración del equipo. Hay que repetirla al cambiar de tipo o de tamaño de etiqueta.',
              'Es la causa de la inmensa mayoría de estos casos y no cuesta nada.'] },
        { t: 'Tipo de sensor mal elegido',
          c: ['Si el material lleva marca negra por detrás, el sensor debe ir en modo marca negra, no en separación.',
              'Con etiqueta continua hay que indicar la longitud a mano: sin gap, el equipo no sabe dónde cortar.'] },
        { t: 'Sensor sucio', pieza: 'limpieza',
          c: ['El polvo de papel sobre el sensor le hace ver separaciones que no existen.'] }
      ]
    },
    {
      id: 'arruga',
      titulo: 'El ribbon se arruga y la impresión sale con pliegues',
      causas: [
        { t: 'Tensión desigual del ribbon',
          c: ['Comprueba que las bobinas están bien asentadas y que el ribbon entra recto, sin sesgo.',
              'Un ribbon que sale torcido de origen arruga siempre, por bien montado que esté.'] },
        { t: 'Presión del cabezal descompensada',
          c: ['Si la arruga sale siempre del mismo lado, iguala la presión.',
              'Prueba a bajar la presión total: mucha gente la lleva más alta de lo necesario.'] },
        { t: 'Ribbon y etiqueta de anchos muy distintos', pieza: 'Ribbons y cintas',
          c: ['Un ribbon mucho más ancho que la etiqueta tiende a plegarse en los bordes.'] }
      ]
    },
    {
      id: 'pega',
      titulo: 'La etiqueta se pega, se atasca o sale sucia',
      causas: [
        { t: 'Rodillo sucio', pieza: 'limpieza',
          c: ['El adhesivo se acumula en el rodillo y arrastra mal. Límpialo con alcohol isopropílico girándolo a mano.'] },
        { t: 'Rodillo gastado o con marcas', pieza: 'Rodillos y platina',
          c: ['Si tiene surcos, zonas planas o el material patina después de limpiarlo, toca cambiarlo.',
              'Un rodillo gastado también produce impresión clara e irregular, porque el contacto con el cabezal deja de ser uniforme.'] },
        { t: 'Cortador sucio o desafilado', pieza: 'Cortadores y dispensadores',
          c: ['Si el atasco se produce justo al cortar, empieza por limpiar el cortador de restos de adhesivo.'] }
      ]
    },
    {
      id: 'descuadre',
      titulo: 'Imprime desplazado, torcido o cortado',
      causas: [
        { t: 'El tamaño de etiqueta del diseño no coincide con el real',
          c: ['Mide la etiqueta con una regla y compáralo con lo que dice el driver o el programa. Un milímetro de diferencia se acumula etiqueta tras etiqueta.'] },
        { t: 'Falta calibrar',
          c: ['Calibra después de cualquier cambio de material. El desplazamiento progresivo es la firma de un sensor descalibrado.'] },
        { t: 'Guías del material sin ajustar',
          c: ['Si sale torcido, las guías laterales están demasiado sueltas y el material serpentea.'] }
      ]
    },
    {
      id: 'nada',
      titulo: 'No imprime: ni se mueve ni responde',
      causas: [
        { t: 'Comunicación', pieza: 'Cables y conectividad',
          c: ['Imprime el informe de configuración desde el propio equipo. Si sale, la impresora está bien y el problema es del ordenador, el driver o la red.',
              'Si no sale, es del equipo o de la alimentación.'] },
        { t: 'Trabajos atascados en la cola',
          c: ['Vacía la cola de impresión y reinicia el spooler antes de tocar nada más.'] },
        { t: 'Driver equivocado',
          c: ['Un driver de otro modelo de la misma marca puede instalar y no imprimir. Comprueba que es el de tu modelo exacto.'] }
      ]
    }
  ];

  // Los grupos tal cual los guarda `custom.grupo_accesorio`, que es como
  // vienen en la respuesta de la ficha.
  var LIMPIEZA = {
    titulo: 'Kit de limpieza',
    texto: 'Alcohol isopropílico y bastoncillos, o el kit de limpieza del ' +
      'fabricante. Con la impresora apagada y el cabezal frío.'
  };

  /* ---------- Interfaz ---------- */

  function decir(t, error) {
    aviso.textContent = t || '';
    aviso.hidden = !t;
    aviso.classList.toggle('di__aviso--error', !!error);
  }

  function pintarSintomas() {
    SINTOMAS.forEach(function (s) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'di__sintoma';
      b.textContent = s.titulo;
      b.addEventListener('click', function () { elegirSintoma(s); });
      zonaSintomas.appendChild(b);
    });
  }

  function elegirSintoma(s) {
    estado.sintoma = s;
    estado.tecnologia = null;
    zonaRes.innerHTML = '';
    zonaPieza.hidden = true;
    decir('');
    [].forEach.call(zonaSintomas.querySelectorAll('.di__sintoma'), function (b) {
      b.setAttribute('aria-pressed', String(b.textContent === s.titulo));
    });
    if (s.pregunta) {
      zonaTec.hidden = false;
      return;
    }
    zonaTec.hidden = true;
    pintarCausas(s, null);
  }

  function pintarCausas(s, tec) {
    var causas = s.causas.filter(function (c) { return !c.si || c.si === tec; });
    zonaRes.innerHTML = '';

    var h = document.createElement('h2');
    h.textContent = s.titulo;
    zonaRes.appendChild(h);

    var p = document.createElement('p');
    p.className = 'di__orden';
    p.textContent = 'Por orden: empieza por lo primero, que es lo que no cuesta ' +
      'dinero. La última causa suele ser la única que obliga a comprar algo.';
    zonaRes.appendChild(p);

    var ol = document.createElement('ol');
    ol.className = 'di__causas';
    causas.forEach(function (c) {
      var li = document.createElement('li');
      var t = document.createElement('h3');
      t.textContent = c.t;
      li.appendChild(t);
      c.c.forEach(function (linea) {
        var x = document.createElement('p');
        x.textContent = linea;
        li.appendChild(x);
      });
      if (c.pieza) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'button button--secondary di__pieza-boton';
        b.textContent = c.pieza === 'limpieza'
          ? 'Cómo limpiarlo'
          : 'Ver ' + c.pieza.toLowerCase() + ' para mi equipo';
        b.addEventListener('click', function () { pedirModelo(c.pieza); });
        li.appendChild(b);
      }
      ol.appendChild(li);
    });
    zonaRes.appendChild(ol);
  }

  function pedirModelo(grupo) {
    zonaPieza.hidden = false;
    zonaPieza.innerHTML = '';

    if (grupo === 'limpieza') {
      var d = document.createElement('div');
      d.className = 'di__limpieza';
      d.innerHTML = '<h3>' + LIMPIEZA.titulo + '</h3><p>' + LIMPIEZA.texto + '</p>' +
        '<p>No hace falta comprar nada especial: alcohol isopropílico de al ' +
        'menos 90° y bastoncillos sin pelusa sirven. Nunca uses objetos ' +
        'metálicos ni alcohol etílico sobre el cabezal.</p>';
      zonaPieza.appendChild(d);
      zonaPieza.scrollIntoView({ block: 'nearest' });
      return;
    }

    var h = document.createElement('h3');
    h.textContent = grupo + ' compatibles con tu equipo';
    zonaPieza.appendChild(h);

    var p = document.createElement('p');
    p.className = 'di__pista';
    p.textContent = 'Dinos el modelo o la referencia y te decimos cuál le ' +
      'corresponde. La referencia está en la etiqueta del equipo.';
    zonaPieza.appendChild(p);

    var f = document.createElement('form');
    f.className = 'di__form';
    var i = document.createElement('input');
    i.type = 'search';
    i.className = 'di__campo';
    i.placeholder = 'ZD621, ZT411, PM45…';
    i.setAttribute('aria-label', 'Modelo o referencia del equipo');
    var b = document.createElement('button');
    b.type = 'submit';
    b.className = 'button';
    b.textContent = 'Buscar';
    f.appendChild(i);
    f.appendChild(b);
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var q = i.value.trim();
      if (q.length < 2) { decir('Escribe al menos dos caracteres.', true); return; }
      buscarPiezas(q, grupo);
    });
    zonaPieza.appendChild(f);

    var salida = document.createElement('div');
    salida.id = 'di-salida';
    zonaPieza.appendChild(salida);
    zonaPieza.scrollIntoView({ block: 'nearest' });
  }

  /* ---------- Datos ---------- */

  function esperar(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function pedir(url, reintentos) {
    reintentos = reintentos == null ? 1 : reintentos;
    // Sin cabecera Accept: ver la nota de cabecera de este fichero.
    return fetch(url).then(function (r) {
      if (r.status === 429 || r.status === 430) {
        if (reintentos > 0) {
          return esperar(1200).then(function () { return pedir(url, reintentos - 1); });
        }
        var e = new Error('throttle'); e.throttle = true; throw e;
      }
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function fichaDe(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return pedir('/products/' + encodeURIComponent(handle) + '?view=compatibles')
      .then(function (d) {
        if (!d || Object.prototype.toString.call(d.accesorios) !== '[object Array]') {
          return null;
        }
        cache[handle] = d;
        return d;
      });
  }

  function buscarPiezas(consulta, grupo) {
    var salida = raiz.querySelector('#di-salida');
    salida.innerHTML = '';
    decir('');
    cargando.hidden = false;

    pedir('/search/suggest.json?q=' + encodeURIComponent(consulta) +
      '&resources[type]=collection&resources[limit]=5')
      .then(function (d) {
        var cols = (d.resources && d.resources.results &&
          d.resources.results.collections) || [];
        if (!cols.length) return null;
        return pedir('/collections/' + encodeURIComponent(cols[0].handle) +
          '?view=compatibles').then(function (c) {
            var ok = c && c.es_modelo === true && c.referencias &&
              c.referencias.length && (c.total || 0) <= 60;
            return ok ? c : null;
          }, function () { return null; });
      }, function () { return null; })
      .then(function (col) {
        if (!col) {
          cargando.hidden = true;
          decir('No he encontrado ese modelo. Prueba con el nombre del modelo ' +
            '(ZD621, ZT411) tal y como aparece en el frontal del equipo.', true);
          return;
        }
        return fichaDe(col.referencias[0].handle).then(function (f) {
          cargando.hidden = true;
          if (!f) {
            decir('No he podido leer las piezas de ese modelo. Escríbenos y te ' +
              'decimos cuál te corresponde.', true);
            return;
          }
          pintarPiezas(f, col, grupo, salida);
        });
      })
      .catch(function (e) {
        cargando.hidden = true;
        decir(e && e.throttle
          ? 'La tienda está recibiendo muchas consultas. Espera unos segundos y ' +
            'vuelve a intentarlo.'
          : 'No he podido consultar la tienda (' + e.message + ').', true);
      });
  }

  function pintarPiezas(ficha, col, grupo, salida) {
    var todo = ficha.accesorios.concat(ficha.consumibles);
    var items = todo.filter(function (x) { return x.grupo === grupo; });

    var cab = document.createElement('p');
    cab.className = 'di__equipo';
    cab.textContent = (col.modelo || col.titulo) + ' · ' + items.length + ' ' +
      grupo.toLowerCase();
    salida.appendChild(cab);

    if (!items.length) {
      var v = document.createElement('p');
      v.className = 'di__aviso';
      v.innerHTML = 'Para este modelo no tenemos ' + grupo.toLowerCase() +
        ' mapeados todavía. <a href="/pages/contacto">Escríbenos</a> con la ' +
        'referencia del equipo y te decimos cuál le corresponde.';
      salida.appendChild(v);
      return;
    }

    var ul = document.createElement('ul');
    ul.className = 'di__piezas';
    items.forEach(function (x) {
      var li = document.createElement('li');
      if (x.imagen) {
        var im = document.createElement('img');
        im.src = x.imagen; im.alt = ''; im.loading = 'lazy';
        li.appendChild(im);
      }
      var caja = document.createElement('div');
      var a = document.createElement('a');
      a.href = x.url; a.textContent = x.titulo; a.className = 'di__pieza-nombre';
      caja.appendChild(a);
      if (x.sku) {
        var s = document.createElement('span');
        s.className = 'di__pieza-sku'; s.textContent = 'Ref. ' + x.sku;
        caja.appendChild(s);
      }
      if (x.precio) {
        var pr = document.createElement('span');
        pr.className = 'di__pieza-precio';
        pr.textContent = (x.precio / 100).toLocaleString('es-ES',
          { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
        caja.appendChild(pr);
      }
      var e = document.createElement('span');
      e.className = 'di__pieza-estado';
      e.textContent = x.disponible ? 'En stock' : 'Bajo pedido · ~4 semanas';
      caja.appendChild(e);
      li.appendChild(caja);
      ul.appendChild(li);
    });
    salida.appendChild(ul);

    var pie = document.createElement('p');
    pie.className = 'di__nota';
    pie.innerHTML = 'Precios sin IVA. ¿Varias referencias del mismo modelo? ' +
      'Compruébalo en el <a href="/pages/buscador-de-consumibles?q=' +
      encodeURIComponent(col.modelo || '') + '">buscador de consumibles</a>, ' +
      'que las lista todas.';
    salida.appendChild(pie);
  }

  /* ---------- Arranque ---------- */

  pintarSintomas();

  [].forEach.call(zonaTec.querySelectorAll('button'), function (b) {
    b.addEventListener('click', function () {
      estado.tecnologia = b.dataset.tec;
      [].forEach.call(zonaTec.querySelectorAll('button'), function (o) {
        o.setAttribute('aria-pressed', String(o === b));
      });
      pintarCausas(estado.sintoma, estado.tecnologia);
    });
  });

  /* Parametros de URL: ?s=rayas&t=tt&g=Cabezales de impresión&m=ZD621
     Sirven para enlazar un sintoma concreto -desde un correo, una ficha o una
     guia- y son ademas la unica forma de probar esta pagina de punta a punta
     contra la tienda de verdad. Con `fetch` simulado los fallos del entorno
     real no aparecen: fue lo que tuvo dos dias roto al buscador. */
  function param(n) {
    var m = location.search.match(new RegExp('[?&]' + n + '=([^&]*)'));
    return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')).trim() : '';
  }
  var s0 = param('s');
  if (s0) {
    var enc = SINTOMAS.filter(function (x) { return x.id === s0; })[0];
    if (enc) {
      elegirSintoma(enc);
      var t0 = param('t');
      if (enc.pregunta && (t0 === 'dt' || t0 === 'tt')) {
        estado.tecnologia = t0 === 'dt' ? DT : TT;
        [].forEach.call(zonaTec.querySelectorAll('button'), function (o) {
          o.setAttribute('aria-pressed', String(o.dataset.tec === estado.tecnologia));
        });
        pintarCausas(enc, estado.tecnologia);
      }
      var g0 = param('g'), m0 = param('m');
      if (g0) {
        pedirModelo(g0);
        if (m0 && g0 !== 'limpieza') {
          var campo = raiz.querySelector('.di__campo');
          if (campo) campo.value = m0;
          buscarPiezas(m0, g0);
        }
      }
    }
  }
})();
